/**
 * Created by Ning Jiang on 5/12/2020.
 */
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {EdisonGameMode} from "../gameMode/EdisonGameMode";

export class EdisonRespinZeroBetController extends RespinZeroBetController {

    constructor() {
        super();
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return data.nextMode === EdisonGameMode.STACKED_RESPIN;
    }
}